module.exports = __webpack_public_path__ + "assets/media/empty_table.fc574e87.svg";